import moment from 'moment'
import _ from 'lodash'
import { MMMM_YYYY } from '@/helpers/date-helper'

export const MONTHS_TO_DISPLAY = 6

export const BaseLayouts = {
  'Grouped Bar': { barmode: 'group' },
  'Stacked Bar': { barmode: 'stack' }
}

export const GraphTypes = {
  STACKED_AREA: 'Stacked Area',
  GROUPED_BAR: 'Grouped Bar',
  STACKED_BAR: 'Stacked Bar',
  LINE: 'Line'
}

export const TraceTypes = {
  AVG_DAYS_AWAITING_REVIEW: 'averageDaysAwaitingReview',
  AVG_DAYS_IN_REVIEW: 'averageDaysInReview',
  AWAITING_REVIEW: 'patientAwaitingReviewCount',
  ENROLLED: 'patientEnrolledCount',
  IN_REVIEW: 'patientInReviewCount',
  FOLLOWING: 'patientFollowingCount',
  MATCHED: 'patientMatchedCount',
  NOT_CONSENTED: 'patientNotConsentedCount',
  NOT_ELIGIBLE: 'patientNotEligibleCount',
  NOT_PRE_SCREENED: 'notPreScreenedCount',
  PLANNED_ENROLLMENT: 'plannedEnrollmentToDate',
  PRE_SCREENED: 'preScreenedCount'
}

export function getBaseLayout(graphType) {
  return BaseLayouts[graphType] || {}
}

export function getBaseTrace(graphType, color) {
  if (graphType === GraphTypes.STACKED_AREA) {
    return {
      stackgroup: 'one',
      fillcolor: `${color}4D`,
      line: {
        color: color
      }
    }
  } else if (graphType === GraphTypes.GROUPED_BAR || graphType === GraphTypes.STACKED_BAR) {
    return {
      type: 'bar',
      marker: {
        color: `${color}B3`
      }
    }
  } else if (graphType === GraphTypes.LINE) {
    return {
      mode: 'lines',
      line: {
        color: `${color}B3`
      }
    }
  } else {
    return {}
  }
}

export function getXAxis(trends) {
  return _.map(trends, trend =>
    moment
      .parseZone(trend.trendDate)
      .local()
      .format(MMMM_YYYY)
  )
}
